import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'How are you so much cheaper than traditional agencies?',
      answer: 'We use AI tools (Claude, GPT-4, OpenClaw) to automate 80-90% of repetitive development work. Traditional agencies use 10-20 developers—we use 2 developers + AI. Lower overhead = lower prices.',
    },
    {
      question: 'Will the quality be good?',
      answer: 'Absolutely. We use the same modern tech stack (Next.js, Supabase, Vercel) that companies like Stripe and Notion use. The difference is speed, not quality.',
    },
    {
      question: 'What if I need changes after delivery?',
      answer: 'First 2 weeks of minor tweaks are included. Major feature additions are scoped and priced separately.',
    },
    {
      question: 'Do you offer maintenance?',
      answer: 'Yes! Optional maintenance plans start at ₹5k/month (bug fixes, minor updates, hosting).',
    },
    {
      question: 'Can you integrate with our existing systems?',
      answer: "Yes. We've integrated with CRMs (HubSpot, Salesforce), ERPs, payment gateways (Razorpay, Stripe), and custom APIs.",
    },
    {
      question: "What if we're not in Bangalore?",
      answer: 'No problem! We work remotely with clients across India via Zoom/Google Meet.',
    },
    {
      question: 'Do you sign NDAs?',
      answer: "Yes, we're happy to sign NDAs before discussing your project.",
    },
  ];

  return (
    <section id="faq" className="section-padding bg-[#f8fafc]" aria-label="Frequently Asked Questions" data-testid="faq-section">
      <div className="section-container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12 md:mb-16"
        >
          <span className="text-sm font-medium tracking-wide uppercase text-[#ff6d00] mb-3 block">
            FAQ
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#212121] mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="faq-headline"
          >
            Frequently Asked Questions
          </h2>
          <p className="text-base md:text-lg text-[#5a6b8c] max-w-2xl mx-auto">
            Everything you need to know about working with us
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-white rounded-xl border border-slate-100 shadow-sm px-6 data-[state=open]:shadow-md transition-all duration-300"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left text-[#212121] font-medium hover:no-underline py-5" data-testid={`faq-trigger-${index}`}>
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#5a6b8c] pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
